import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const SECTOR_COLORS = ["bg-orange-500", "bg-blue-500", "bg-emerald-500", "bg-violet-500", "bg-rose-500", "bg-amber-500", "bg-cyan-500"];

export function useTaxonomy() {
  const [sectors, setSectors] = useState([]);
  const [disciplines, setDisciplines] = useState([]);
  const reload = useCallback(() => Promise.all([
    api.get("/sectors").then((r) => setSectors(r.data)),
    api.get("/disciplines").then((r) => setDisciplines(r.data)),
  ]).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  return { sectors, disciplines, reload };
}
